import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "title", "body", "cta", "children", "eventKey", "selected", "media", "noTopBorder", "noBottomBorder", "setSelected", "disableCollapse", "scrollToContentWhenExpanded"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React, { useRef } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { Anchor } from '../link/anchor';
import { Body } from '../text/body/body';
import { Title } from '../text/title/title';
import styles from './collapsible.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Collapsible = function Collapsible(_ref) {
  var className = _ref.className,
      title = _ref.title,
      body = _ref.body,
      _ref$cta = _ref.cta,
      cta = _ref$cta === void 0 ? null : _ref$cta,
      children = _ref.children,
      eventKey = _ref.eventKey,
      selected = _ref.selected,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? null : _ref$media,
      noTopBorder = _ref.noTopBorder,
      noBottomBorder = _ref.noBottomBorder,
      setSelected = _ref.setSelected,
      disableCollapse = _ref.disableCollapse,
      scrollToContentWhenExpanded = _ref.scrollToContentWhenExpanded,
      rest = _objectWithoutProperties(_ref, _excluded);

  var isExpanded = String(eventKey) === selected;
  var isActive = !(disableCollapse && isExpanded);
  var contentRef = useRef(null);

  var handleOnEntered = function handleOnEntered() {
    if (scrollToContentWhenExpanded) {
      /**
       * Timeout is needed to allow the animation to complete
       * before scrolling into view.
       */
      setTimeout(function () {
        if (!contentRef.current) return;
        var headerOffset = 80;
        var contentPosition = contentRef.current.getBoundingClientRect().top;
        var offsetPosition = contentPosition + window.scrollY - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }, 300);
    }
  };

  var handleOnClick = function handleOnClick() {
    if (disableCollapse && isExpanded) {
      return;
    }

    setSelected("".concat(isExpanded ? -1 : eventKey));
  };

  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    ref: contentRef,
    onClick: handleOnClick,
    className: classNames(className, styles['collapsible-wrapper'], 'collapsible', {
      'cursor-pointer': isActive,
      'collapsible-expanded': isExpanded,
      'collapsible-no-top-border': noTopBorder,
      'collapsible-no-bottom-border': noBottomBorder,
      'pt-300': isExpanded && cta,
      'py-300': !isExpanded || !cta
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: classNames(styles['collapsible-wrapper'], 'd-flex flex-column align-items-center'),
      children: [/*#__PURE__*/_jsx("div", {
        onClick: handleOnClick,
        className: classNames('d-flex align-items-center justify-content-between w-100 gap-300 pe-50', {
          'cursor-pointer': isActive
        }),
        children: typeof title === 'string' ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Title, {
            className: "mb-0",
            render: "h5",
            as: "h3",
            children: title
          }), /*#__PURE__*/_jsx(Anchor, {
            className: classNames('collapsible-icon', {
              'disable pe-none': disableCollapse && isExpanded
            }),
            size: "md",
            iconEnd: "ChevronDown"
          })]
        }) : title
      }), /*#__PURE__*/_jsx(Collapse, {
        "in": isExpanded,
        onEnter: handleOnEntered,
        children: /*#__PURE__*/_jsxs("div", {
          className: "w-100",
          children: [/*#__PURE__*/_jsx(Body, {
            className: "pt-150",
            children: body || children
          }), cta && /*#__PURE__*/_jsx("div", {
            onClick: function onClick(e) {
              e.stopPropagation();
            },
            className: classNames('py-300', styles['cta-wrapper']),
            children: cta
          }), media]
        })
      })]
    })
  }));
};